import React from "react";

const SvgLivingArea = (props) => (
  <svg width={36} height={30} {...props}>
    <g stroke="#082746" fill="none" fillRule="evenodd">
      <path d="M20.136 16.864V29.5H35.5V16.864H20.136z" />
      <path d="M.818.682v27.273" strokeLinecap="square" />
      <path d="M.818 27.955h14.727V14.318h14.728V.682H.818" />
    </g>
  </svg>
);

export default SvgLivingArea;
